import styled from "styled-components";

export const LoginWidgetContainer = styled.div`
//  text-align: center;
 background: rgba(0, 0, 0, 0.6);
 padding: 28px 20px 20px 20px;
 width: 18%; 
//  height: 65vh; 
max-width:400px;
 min-height: 400px; 
 margin-right: 52px;
 border-radius: 10px; 

 @media screen and (max-width: 1600px){
    &{
        width: 25%;
    }

 @media screen and (max-width: 1180px)and (orientation : landscape){
    width: 30vw; 
}
@media screen and (max-width: 576px){  //added for mobile screens
    &{
        max-width: unset;
    }
}
 @media screen and (max-width: 750px){
    &{
        width:100vw;
        text-align:center;
        height: 100vh;
        margin-right: 0;
        display: flex;
        flex-flow: column;
        justify-content: center;
    }
}
@media only screen and (min-width: 750px) and (max-width: 1199px)  and (orientation: portrait) {
    min-height:500px;
    max-height:500px;
    width:400px;
    margin-right:0px;
  }

@media only screen and (min-width: 750px) and (max-width: 1199px) and (orientation: landscape) {
        width: 38%; 
    
}
`
export const LoginLinkContainer = styled.div`
    padding: 0 2%;
    ${props => props.help_support && `
        margin: 8% 0 0;
        text-align: center;
        font-family: 'Lato-Bold';
     `
    }
`

export const LoginWidgetContainerOther = styled.div`
 background: #FFFFFF;
 padding: 28px 20px 20px 20px;
 width: 18%;  
//max-width:360px;
 min-height: 312px; 
 border-radius: 10px; 
 position: absolute;

 @media screen and (max-width: 740px){
    width: 90%;
    left: unset;
    right: unset;
}
@media screen and (min-width: 750px) and (max-width: 1199px){
        width: 60%;
        left: unset;
        right: unset;
    }
 @media screen and (min-width: 1200px) and (max-width: 1600px){
        width: 28%;
    }
 @media screen and (min-width: 1600px){
     width: 23%;
 }
`
export const LoginWidgetContainerNZ = styled.div`
 background: #FFFFFF;
 padding: 28px 20px 20px 20px;
 width: 18%;  
//max-width:360px;
 min-height: 312px; 
 border-radius: 10px; 
 position: absolute;
 left: 10%;
 //left: ${props=> props.isNZ ? "10%": "unset" };
 //right: ${props=> props.isNZ ? "unset" : "5%" };

 @media screen and (max-width: 740px){
    width: 90%;
    left: unset;
    right: unset;
}
@media screen and (min-width: 750px) and (max-width: 1199px){
        width: 60%;
        left: unset;
        right: unset;
    }
 @media screen and (min-width: 1200px) and (max-width: 1600px){
        width: 28%;
    }
 @media screen and (min-width: 1600px){
     width: 23%;
 }
`



